import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const DeliveryList = () => {
  const [filters, setFilters] = useState({
    school_id: "",
    class_id: "",
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const today = new Date().toISOString().split("T")[0]; // "YY
  const [loadingReqQty, setLoadingReqQty] = useState(false);
  const [schoolList, setSchoolList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [deliveryList, setDeliveryList] = useState([]);
  const [deliveryListItemWise, setDeliveryListItemWise] = useState([]);
  const [showReportHeader, setShowReportHeader] = useState(false);
  const [sectionlList, setSectionList] = useState([]);


const fetchSectionList = async() =>{
      try{
      const token = localStorage.getItem("token");
          const response = await axios.get(`${BASE_URL}/sectionList`,

          { headers: { Authorization: `Bearer ${token}` } }
      )

      if(response.data.status === true){
          setSectionList(response.data.data.sectionList || []);
      }
      else{
          console.log("error sectionlist");
      }

      }catch(err){
         console.error("Student count error", err);
        if (handle401(err)) return;
      }
    }


  const fetchDeliveryList = async (pageNumber = 1) => {
    if (!filters.school_id) {
      Swal.fire("Warning", "Please select school", "warning");
      return;
    }

    try {
      setLoading(true);
  const token = localStorage.getItem("token");

      const payload = {
        school_id: filters.school_id,
        class_id: filters.class_id || "",
        page: pageNumber.toString(),
        per_page: perPage.toString(),
      };

      const res = await axios.post(`${BASE_URL}/deliveryList`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.status) {
        setDeliveryList(res.data.data.student_wise || []);
        setDeliveryListItemWise(res.data.data.item_size_summary || []);
        setTotalRecords(res.data.data.total || 0);
        setTotalPages(res.data.data.last_page || 1);
        setPage(pageNumber);
      } else {
        setDeliveryList([]);
        Swal.fire("Error", res.data.message, "error");
      }
    } catch (err) {
      handle401(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    if (isNaN(d)) return "-";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`; // DD/MM/YYYY
  };

  const loadSchools = async () => {
    try {
  const token = localStorage.getItem("token");
      const municipality_id = localStorage.getItem("municipality_id");

      let payload = {};

      payload = {
        municipality_id: municipality_id,
      };

      const res = await axios.post(`${BASE_URL}/schoolList`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSchoolList(res.data.data || []);
    } catch (err) {
      handle401(err);
    }
  };

  const loadClasses = async () => {
    try {
  const token = localStorage.getItem("token");
      const res = await axios.get(`${BASE_URL}/classList`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClassList(res.data.data.class_list || []);
    } catch (err) {
      handle401(err);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const selectedSchool = schoolList.find(
  (school) => school.id === Number(filters.school_id)
);



  useEffect(() => {
    loadSchools();
    loadClasses();
    fetchSectionList();
  }, []);

  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* ================= FILTER CARD ================= */}
      <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter"></i> Delivered Items List
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-black">
                  School <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  value={filters.school_id}
                  onChange={(e) =>
                    setFilters({ ...filters, school_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select School</option>

                  {schoolList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-black">
                  Class (Optional)
                </Form.Label>
                <Form.Select
                  value={filters.class_id}
                  onChange={(e) =>
                    setFilters({ ...filters, class_id: e.target.value })
                  }
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                >
                  <option value="">Select Class</option>

                  {classList.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

             {/* <Col md={3}>
                                          <Form.Group className="mb-3">
                                            <Form.Label className="fw-semibold text-black">
                                              Section <span className="text-danger">*</span>
                                            </Form.Label>

                                             <Form.Select
            style={{
                                borderRadius: "10px",
                                border: "2px solid #1565C1",
                              }}
                                            >
                                              <option value="">Select Section</option>

                                              {sectionlList.map((sec) => (
                                                <option key={sec.id} value={sec.id}>
                                                  {sec.section_name}
                                                </option>
                                              ))}
                                            </Form.Select>
                                          </Form.Group>
                                        </Col> */}

            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark">
                  Record Showing
                </Form.Label>

                <Form.Select
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #1565C1",
                  }}
                  value={perPage}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setPerPage(value);
                    setPage(1);
                  }}
                >
                  <option value={10}>10 Per Page</option>
                  <option value={25}>25 Per Page</option>
                  <option value={50}>50 Per Page</option>
                  <option value={100}>100 Per Page</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Row>
                <Col md={2} className="mt-3">
              <Button
                className="w-100 fw-semibold text-white"
                style={{ background: "#1565C1", borderRadius: "10px" }}
                onClick={() => {
                  if (!filters.school_id) {
                    Swal.fire(
                      "Alert",
                      "Please select atleast one School",
                      "warning",
                    );
                    return;
                  }
                  setShowReportHeader(true);
                  fetchDeliveryList();
                }}
              >
                <i className="fa-solid fa-magnifying-glass me-2"></i> Search
              </Button>
            </Col>

            <Col md={2} className="mt-3">
              <Button
                className="w-100 fw-semibold text-white"
                style={{ background: "#E53935", borderRadius: "10px" }}
                onClick={() => {
                  setFilters({
                    school_id: "",
                    class_id: "",
                  });
setShowReportHeader(false);
                  setPage(1);
                  setPerPage(10);
                  setDeliveryList([]);
                  setDeliveryListItemWise([]);
                  setTotalRecords(0);
                  setTotalPages(1);
                }}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
              </Button>
            </Col>
            </Row>
          </Row>
        </Card.Body>
      </Card>


{showReportHeader && selectedSchool && (


    <div className="text-center mb-4">
          <h4 className="fw-bold text-dark mb-1">{selectedSchool.name}</h4>
          <div className="fs-6 text-success">
            School-wise Delivery List (As on {today})
          </div>
    </div>

)}





      {/* ================= TABLE ================= */}

      <div className="mt-3">
        <Row>
          {deliveryListItemWise.map((item, index) => (
            <Col md={2} key={index} className="mb-3">
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2"
                style={{
                  background: "linear-gradient(135deg, #42A5F5, #1E88E5)",
                  borderRadius: "50px",
                  boxShadow: "0 4px 12px rgba(30,136,229,0.35)",
                  color: "#fff",
                }}
              >
                <div style={{ lineHeight: "1.2" }}>
                  <div style={{ fontSize: "16px", fontWeight: "600" }}>
                    {item.item_name}
                  </div>
                  <div style={{ fontSize: "16px", opacity: 0.9 }}>
                    Size: {item.size}
                  </div>
                </div>

                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {item.total_quantity}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="blue-spinner"></div>

          <div className="loading-line">
            <div className="loading-progress"></div>
          </div>

          <p className="loading-text">Loading, please wait...</p>
        </div>
      )}
      {!loading && (
        <Card
          className="mb-4 border-0"
          style={{
            background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
            boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
          }}
        >
          <Table bordered hover responsive striped>
            <thead>
              <tr>
                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  SL
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  School
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Class
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Section
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Roll no
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Gender
                </th>

                <th
                  style={{
                    padding: "5px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    borderTopLeftRadius: "10px",
                    backgroundColor: "#edf7fe",
                    height: "10px",
                    borderBottom: "1px solid black",
                    borderTop: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  Items
                </th>
              </tr>
            </thead>
            <tbody>
              {!loading && deliveryList.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center text-muted">
                    No records found
                  </td>
                </tr>
              )}

              {deliveryList.map((row, index) => (
                <tr key={row.student_id}>
                  <td className="text-center">{index + 1}</td>

                  <td className="text-center">{row.school_name}</td>
                  <td className="text-center">{row.class_name}</td>
                                    <td className="text-center">{row.section_name}</td>


                  <td className="text-center">{row.roll_no}</td>
                  <td className="text-center">{row.gender}</td>

                  <td className="text-center">
                    <div className="d-flex flex-wrap justify-content-center gap-2">
                      {row.items?.map((item, i) => (
                        <span
                          key={i}
                          style={{
                            background:
                              "linear-gradient(135deg, #42A5F5, #1E88E5)",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "20px",
                            fontSize: "16px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.item_name} ({item.size}) × {item.quantity}
                        </span>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <nav>
                <ul className="pagination shadow-sm">
                  <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchDeliveryList(1)}
                    >
                      «
                    </button>
                  </li>

                  <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchDeliveryList(page - 1)}
                    >
                      ‹
                    </button>
                  </li>

                  {getPageNumbers().map((p) => (
                    <li
                      key={p}
                      className={`page-item ${page === p ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => fetchDeliveryList(p)}
                      >
                        {p}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      page === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchDeliveryList(page + 1)}
                    >
                      ›
                    </button>
                  </li>

                  <li
                    className={`page-item ${
                      page === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchDeliveryList(totalPages)}
                    >
                      »
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </Card>
      )}
    </div>
  );
};

export default DeliveryList;
